module.exports = {
  differenceHour,
  insertHour,
  getDates
};

// function to get difference hour
// need to write in new option data
// split for insert +30 min
function differenceHour(hour1, hour2) {
  let hour1Split = hour1.split(':')
  let hour2Split = hour2.split(':')

  let hourStart = parseInt(hour1Split[0])
  let hourEnd = parseInt(hour2Split[0])

  let minuteStart = parseInt(hour1Split[1])
  let minuteEnd = parseInt(hour2Split[1])

  let formatHour1 = hour1.replace(':', '.')
  let formatHour2 = hour2.replace(':', '.')

  let diff = Math.round(formatHour2 - formatHour1)
  diff += 0.5

  let finish = 0
  let hourArray = []
  hourArray.push(hour1)

  while (finish != diff) {
    if (minuteStart == 30) {
      hourStart += 1
      minuteStart = 0.0
    } else {
      minuteStart += 30
    }
    hourArray.push(hourStart + ':' + minuteStart)
    diff -= 0.5
  }
  let hourArray2 = []
  hourArray.forEach((item) => {
    if (item.endsWith(':0')) {
      hourArray2.push(item.replace(':0', ':00'))
    } else {
      hourArray2.push(item.replace(':30', ':30'))
    }
  })
  return hourArray2
}

// function for write option in customSelect
// with new hour / error
function insertHour(containerHour, finalHour, customSelect) {
  let hourSelect = document.querySelector('[name="heure"]')
  if (hourSelect != null) {
    for (let i = 0; i < finalHour.length; i++) {
      let option = document.createElement("option")
      option.value = finalHour[i]
      option.innerHTML = finalHour[i]
      hourSelect.appendChild(option)
    }
  }
}

// function for return array date where date > today
function getDates(startDate, endDate) {
  const dates = []
  let currentDate = startDate
  const addDays = function (days) {
    const date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates
}